import * as sentryNextJs from '@sentry/nextjs';

const { captureException } = sentryNextJs;

export function getErrorMessage(error: any) {
  if (!error) return;

  if (typeof error === 'string') return error;

  if (error.status) {
    const { data, message, status } = error;

    switch (status) {
      case 400: {
        return data?.message || "Something's not right with this request.";
      }
      case 401: {
        return data?.message || "You'll need to sign in to continue.";
      }
      case 403: {
        return "You don't have permission to access this resource.";
      }
      case 404: {
        return "We couldn't find what you're looking for.";
      }
      case 422: {
        return data?.message || message || 'Invalid request.';
      }
      case 429: {
        return data?.message || message || 'Too many requests. Please try again later.';
      }
      case 500: {
        return "Something went wrong on our end. We're working to fix it.";
      }
    }

    return data?.message || `Unexpected error (${status}). Please try again later.`;
  }

  return error.message || 'An error occurred.';
}

export async function captureError(
  error: any,
  hint?: {
    [key: string]: any;
    extra?: Record<string, any>;
  },
) {
  if (error instanceof Error) {
    // eslint-disable-next-line no-console
    console.error('captured error:', error, hint);
    captureException(error, hint);
  } else if (error instanceof Response || error.response instanceof Response) {
    let body: any = undefined;
    try {
      body = await error.json();
    } catch {
      // ignore
    } finally {
      // eslint-disable-next-line no-console
      console.error('captured fetch error:', error, hint, body);
      captureException(new Error(`Fetch error: ${getErrorMessage(error)}`), {
        ...hint,
        extra: {
          ...error,
          ...hint?.extra,
          body,
        },
      });
    }
  } else {
    // eslint-disable-next-line no-console
    console.error('captured error:', error, hint);
    captureException(new Error('Unknown error'), {
      ...hint,
      extra: {
        error,
        ...hint?.extra,
      },
    });
  }
}
